import styles from "./reviews-page.module.css";
import AiIconV2 from "../Icons/ai-icon-v2";
import { actions } from "./reviewListReducer";
import { formatAsAgoString } from "../../Util/dateUtils";

const RespondButton = ({ onClick, disabled }) => {
  return (
    <button className={styles.respondButton} onClick={onClick} disabled={disabled}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M4.77913 8.81232L7.27157 11.3046C7.38307 11.4162 7.43807 11.5468 7.43657 11.6963C7.4352 11.8458 7.37632 11.9787 7.25995 12.0951C7.14357 12.2037 7.01182 12.2599 6.8647 12.2638C6.7177 12.2676 6.58601 12.2113 6.46963 12.0951L3.09895 8.72438C2.96332 8.58876 2.89551 8.43057 2.89551 8.24982C2.89551 8.06907 2.96332 7.91088 3.09895 7.77526L6.46963 4.40457C6.57351 4.30082 6.70207 4.24769 6.85532 4.24519C7.0087 4.24282 7.14357 4.29594 7.25995 4.40457C7.37632 4.52094 7.43451 4.65463 7.43451 4.80563C7.43451 4.95651 7.37632 5.09013 7.25995 5.20651L4.77913 7.68732H11.8119C12.7965 7.68732 13.6364 8.03494 14.3315 8.73019C15.0268 9.42532 15.3744 10.2652 15.3744 11.2498V13.3123C15.3744 13.4719 15.3205 13.6056 15.2128 13.7132C15.1051 13.8209 14.9715 13.8748 14.8119 13.8748C14.6523 13.8748 14.5186 13.8209 14.411 13.7132C14.3033 13.6056 14.2494 13.4719 14.2494 13.3123V11.2498C14.2494 10.5767 14.0114 10.0022 13.5354 9.52632C13.0595 9.05032 12.485 8.81232 11.8119 8.81232H4.77913Z"
          fill="#525252"
        />
      </svg>
      <div className={styles.respondButtonText}>Respond</div>
    </button>
  );
};

const ReviewActions = ({ review, dispatch }) => {
  const onlyButton = !review.chatRoomHasFirstMessage;

  if (onlyButton || !review.planSupportsReviewChat) {
    return (
      <div>
        <RespondButton
          disabled={!review.planSupportsReviewChat}
          onClick={() =>
            dispatch({
              type: actions.OPEN_RESPONSE_VIEW,
              key: review.key,
            })
          }
        />
        {!review.planSupportsReviewChat && (
          <div style={{ color: 'red', marginTop: 8, fontSize: 12 }}>
            Upgrade to Branded Elite or Above to respond to this review
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className={styles.responseContainer}>
        <div className={styles.singleResponseContainer}>
          <div className={styles.responseHeader}>
            <div className={styles.responseHeaderName}>
              <div>{review.companyName}</div>
              {/* TOOD */}
              {/* <div className={styles.aiIcon}>
                <AiIconV2 />
              </div> */}
            </div>
            <div className={styles.responseHeaderTimeText}>
              {formatAsAgoString(review.chatRoomFirstMessageSentAt)}
            </div>
          </div>
          <div className={styles.responseText}>
            {review.chatRoomFirstMessage}
          </div>
        </div>
        <RespondButton
          onClick={() =>
            dispatch({
              type: actions.OPEN_RESPONSE_VIEW,
              key: review.key,
            })
          }
        />
      </div>
    );
  }
};

export default ReviewActions;
